export default __webpack_public_path__ + "static/media/69.efadb79a.jpeg";